module.exports = __webpack_public_path__ + "static/media/residential-building-large.7086ced4.png";